export default "__VITE_ASSET__CwSt1ZaI__"